import { createSlice } from "@reduxjs/toolkit";
import { createAdminAPI } from "../../services/adminManagement";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const createAdminSlice = createSlice({
  name: "createAdmin",
  initialState: data,
  reducers: {
    createAdminInfo(state) {
      state.isLoading = true;
    },
    createAdminInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    createAdminInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    createAdminInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const createAdminHandler = (payload) => async (dispatch) => {
  try {
    dispatch(createAdminAction.createAdminInfo());
    const response = await createAdminAPI(payload);
    dispatch(createAdminAction.createAdminInfoSuccess(response));
  } catch (e) {
    dispatch(createAdminAction.createAdminInfoFailure(e));
  }
};

export default createAdminSlice.reducer;
export const createAdminAction = createAdminSlice.actions;
